module.exports = __webpack_public_path__ + "cb9ee4082173c79156721f4122cd54d9.webp";